<mat-card class="example-card">
	<mat-card-header>
    <div mat-card-avatar class="header-image"></div>
    <mat-card-title>Contatti</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-icon fontSet="fa" fontIcon="fa-envelope"></mat-icon><a href="mailto:info@gpautomazioni.it"><span>info@gpautomazioni.it</span></a><br>
    <mat-icon fontSet="fa" fontIcon="fa-phone"></mat-icon><a href="tel:3381775946"><span>3381775946</span></a><br>
    <mat-icon fontSet="fab" fontIcon="fa-facebook"></mat-icon><a href="https://www.facebook.com/el.gp.snc" style="font-weight: bold;">Trovaci su Facebook</a>
  </mat-card-content>
</mat-card>
